// extracted by mini-css-extract-plugin
module.exports =  {"list-content":"list-content--quBqk","listContent":"list-content--quBqk","list":"list--dFSAi","item-wrapper":"item-wrapper--mjNW9","itemWrapper":"item-wrapper--mjNW9"};